import { Box, Flex, Image } from '@chakra-ui/react';

import logo from 'Asset/image/logo.svg';
import errorImage from 'Asset/image/errror-image.svg';
import { errorDescText, errorTitleText, logoutText, reloadtText } from 'Const/error';
import { TextBold, TextRegular } from 'UiKit/typography';
import ButtonOutline from 'UiKit/button/buttonOutline';
import ButtonSolid from 'UiKit/button/buttonSolid';
import useLogout from 'Domain/logout/usePostLogout';
import { CloseCircleIcon } from 'Asset/icon';
import { Condition } from 'Component/others';

import styles from './styles.module.css';

const ErrorPage = ({ error }) => {
  const errorMessage = error?.error?.message;

  const { mutate: onLogout } = useLogout();

  return (
    <Box className={styles['error-page__container']}>
      <Image src={logo} alt="logo" className={styles['logo__image']} />
      <Image src={errorImage} alt="error illustration" className={styles['ilustration__image']} />
      <TextBold className={styles['error-title__text']}>{errorTitleText}</TextBold>
      <TextRegular className={styles['error-description__text']}>{errorDescText}</TextRegular>
      <Flex className={styles['button__container']}>
        <ButtonOutline onClick={() => onLogout({ isReload: true })}>
          <TextRegular className={styles['logout__text']}>{logoutText}</TextRegular>
        </ButtonOutline>

        <ButtonSolid onClick={() => window.location.reload()}>
          <TextRegular className={styles['main-page__text']}>{reloadtText}</TextRegular>
        </ButtonSolid>
      </Flex>

      <Condition statement={errorMessage}>
        <Box className={styles['error-detail__container']}>
          <Flex className={styles['error-detail__box']}>
            <CloseCircleIcon color="var(--color-error40)" />
            <TextRegular>{errorMessage}</TextRegular>
          </Flex>
        </Box>
      </Condition>
    </Box>
  );
};

export default ErrorPage;
